export function addImageCounter(el, selector) {
  const $el = el
  let total

  $el.each(function (index, element) {
    const $item = $(element)

    // PY04777-477 - 725645
    // The counter is not initialised if there is a swiper inside another swiper.
    if (!selector) {
      if ($item.find('.swiper-slider:not(.swiper-slider .swiper-slider)').length) {
        selector = '.swiper-slide'
      } else if ($item.find('[data-swiper-slide]:not([data-swiper-slide] [data-swiper-slide])').length) {
        selector = '[data-swiper-slide]'
      } else {
        selector = '.ss-slide'
      }
    }

    total = $item.find(selector).length
    $item.find(selector).each(function (i, item) {
      $(item).prepend(`<div class="e-image-counter">${i + 1}/${total}</div>`)
    })
  })
}
